import styled from '@emotion/styled';
import React, { useEffect, useState } from 'react';
import Button from '../../../../../../components/button';
import ModalSlider from '../../../../../../components/modal-slider/modal-slider';
import { createPlanoTuss, findAllPlanoTuss, findPlanoTussById, updatePlanoTuss } from '../../../../../../services/vizi-plano-tuss';
import { DadosPlanoTuss } from './dados-planos-tuss';
import PlanosTussList from './list';



export const ModalProcedimentos = ({
  openModal,
  onCloseModal,
  setNotification,
  carregarPlanos,
  plano,
  whitelabel }) => {
    const [loading, setLoading] = useState(false);
    const [planosTuss, setPlanosTuss] = useState([]);
    const [modalMode, setModalMode] = useState("view")
    const [dadosPlanoTuss, setDadosPlanoTuss] = useState({})




const getPlanosTuss  = async(variables, whitelabel) =>{
    try{
      setLoading(true)
    const response = await findAllPlanoTuss(variables, whitelabel)
    setPlanosTuss(response)
   }
   catch(error){
    console.log(error)
   }
   finally{
    setLoading(false)
   }
  }
  useEffect(() => {
    getPlanosTuss({
        planoVizi: {
          id:plano.id
        }
    },  whitelabel)

  }, [whitelabel]);
  const titlePrimeiroStep = () =>{
    switch (modalMode) {
      case 'create':
        return 'Vincular Procedimentos'
      case 'update':
        return 'Atualizar um procedimento'
      default:
        return 'Procedimentos vinculados'
    }
  };

  const handleChangeMode = async(mode, plano) =>{
    try {
      const response = await findPlanoTussById({ id: plano?.id || dadosPlanoTuss?.id }, whitelabel);

      setDadosPlanoTuss(response)
      setModalMode(mode)

    } catch(e) {
      console.error(e)
    }
  }
  const handleChange = (key, value) =>{
    setDadosPlanoTuss((planoTuss)=>({...planoTuss, [key]:value}))
  }
  const components = {
    view:<PlanosTussList planosTuss={planosTuss} handleChangeMode={handleChangeMode} />,
    create:<DadosPlanoTuss dadosPlanoTuss={dadosPlanoTuss} handleChange={handleChange} whitelabel={whitelabel}/>,
    update:<DadosPlanoTuss dadosPlanoTuss={dadosPlanoTuss} handleChange={handleChange} whitelabel={whitelabel}/>,
}
  const transformInDecimal = (number) =>{
    const decimal = String(number).replace('%', '')
    return Number(decimal)
  }
  const handleSavePlano = async () => {
    const save = dadosPlanoTuss.id ? updatePlanoTuss : createPlanoTuss

    try {
      setLoading(true);
      const planoRussId = await save({
        ...(dadosPlanoTuss?.id&&{id: dadosPlanoTuss.id}),
      planoTuss: {
        plano : {id:plano.id},
        carencia: dadosPlanoTuss?.carencia,
        qtdeDisponivel: dadosPlanoTuss?.qtdeDisponivel,
        ...(dadosPlanoTuss?.desconto && {desconto: transformInDecimal(dadosPlanoTuss.desconto)}),
        ...(dadosPlanoTuss.descontoAposLimite && {descontoAposLimite: transformInDecimal(dadosPlanoTuss.descontoAposLimite, "")}),
        servico:{
          nome: dadosPlanoTuss?.servicoExibicao?.nome,
          id:dadosPlanoTuss?.servicoExibicao?.id,
          tipoServico: dadosPlanoTuss?.servicoExibicao?.tipoServico,
        },
      }
      }, whitelabel);
      await carregarPlanos();
      setDadosPlanoTuss({});
      if (Boolean(planoRussId)) {
        setNotification({
          variant: 'success',
          isOpen: true,
          message: dadosPlanoTuss?.id ? 'Plano atualizado com sucesso' : 'plano criado com sucesso',
        });
      }
      onCloseModal();
    } catch (error) {
      setNotification({
        variant: 'error',
        isOpen: true,
        message: error.message,
      });
    } finally {
      setLoading(false);
    }
  };



  return (
    <ModalSlider
      isOpen={openModal}
      onClose={() => {
        setDadosPlanoTuss({});
        onCloseModal();
      }}
      title={titlePrimeiroStep()}
    >

      <ContentModal>
        <Content>
        {components[modalMode]}
        </Content>
        <Footer>
          {modalMode !== 'view' &&
          <Button
            style={{
              background:"#ffff",
              color:'#000'
            }}
            disabled={loading}
            onClick={()=>handleChangeMode('view')}>
            {'Voltar'}
          </Button>}
          {modalMode !== 'view' &&
          <Button
            disabled={loading}
            onClick={handleSavePlano}>
            {'Salvar'}
          </Button>}
          {modalMode === 'view' &&
          <Button
            disabled={loading}
            onClick={()=>handleChangeMode('create')}>
            {'Vincular Procedimentos'}
          </Button>}
        </Footer>
      </ContentModal>
    </ModalSlider>
  );
};

const ContentModal = styled.div`
    grid-template-rows: 1fr 80px;
    display: grid;
    height: 100%;
`;

const Content = styled.div`
  height: 100%;
`;

const Footer = styled.div`
  min-height: max-content;
  padding-top: 16px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 4px;
`;

